<template>
<div>
  <div class="columns">
    <div class="column">
      <text-input v-model="filters.search" classes="is-rounded">
        <template #right>
          <div class="buttons has-addons is-rounded">
            <action-button @click="clearFilters" v-if="filters.search.length" class="is-rounded">
              <icon icon="times"/>
            </action-button>
            <action-button @click="runFilters" class="is-rounded">
              <icon icon="search"/>
              <span>Search</span>
            </action-button>
          </div>
        </template>
      </text-input>
    </div>
    <div class="column is-narrow">
      <router-link 
        class="button is-small is-rounded"
        :to="{
          name: 'new-standard-section',
          params: {
            standard: $route.params.standard
          }
        }">
        <icon icon="plus"/>
        <span>New Section</span>
      </router-link>
    </div>
  </div>  

  <div class="columns">
    <div class="column">
      <div class="table-container">
        <table class="table is-fullwidth is-hoverable">
          <thead>
            <tr>
              <th>Section</th>
              <th class="is-narrow has-text-right">Checkpoints</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="section in sections.data" :key="section.id">
              <td>
                <p class="has-text-weight-bold">
                  <router-link 
                    :to="{
                      name: 'section-manager',
                      params: {
                        standard: $route.params.standard,
                        section: section.id,
                      }
                    }">
                    {{ section.title }}
                  </router-link>
                </p>
                <p class="has-text-grey">{{ section.description }}</p>
              </td>
              <td class="has-text-right">
                {{ section.checkpoints_count || 0 }}
              </td>
            </tr>
          </tbody>
        </table>

        <pager :pageable="sections" jump-controls context="Section"/>
      </div>
    </div>
  </div>
</div>  
</template>
<script>
import { getPath } from '@/api/common'
import Paginator from '@/store/models/Paginator'

export default {

  name: 'Standards',

  data: () => ({
    sections: new Paginator,
    loading: false,
    filters: {
      search: ''
    }
  }),

  created() {
    if(this.$route.query.search) {
      this.filters.search = this.$route.query.search;
    }
    this.loadSections()
  },

  methods: {
    loadSections() {
      getPath({
        path: 'api/super' + this.$route.fullPath
      }, ({data}) => {
        this.sections = data
        this.loading = false
      }, error => {})
    },
    runFilters() {
      if(!this.filters.search.length) {
        this.$toast.warning('Please enter a search term.')
        return
      }
      this.$router.push({
        name: 'standard-sections',
        params: { standard: this.$route.params.standard },
        query: this.filters
      })
    },
    clearFilters() {
      this.filters.search = ''
      this.$router.push({
        name: 'standard-sections',
        params: { standard: this.$route.params.standard },
        query: this.filters
      })
    },
    goToPage(page) {
      this.$router.push(page)
    }
  },

  watch: {
    '$route': 'loadSections'
  }

}
</script>